import { FC, HTMLAttributes } from "react";

import { MUIIcon } from ".";

export interface IHeadingAttributes extends HTMLAttributes<HTMLHeadingElement> {
    heading?: string
    tooltip?: string
    icon?: string
    iconClassName?: string
    as?: React.ElementType
}

export const Heading: FC<IHeadingAttributes> = ({
    heading, tooltip, icon, iconClassName, className, children, as: AsComponent = "h1"
}) => {
    return <>
        <AsComponent className={className} title={tooltip}>
            {(icon) && <MUIIcon iconName={icon} className={iconClassName} />}
            <span>{heading}</span>
            {children}
        </AsComponent>
    </>
}